module.exports = __webpack_public_path__ + "static/media/addval_icon.5e1953a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductSelector/asstes/addval_icon.jpg
// module id = 8tDh
// module chunks = 23